import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticClass:"fill-height",attrs:{"fluid":""}},[_c(VOverlay,{attrs:{"z-index":"1000"}},[_c(VCard,{staticClass:"text-center black--text",attrs:{"color":"white"}},[_c(VCardTitle,[_vm._v(_vm._s(_vm.$tt('customOAuthMessage')))]),_c(VCardText,[_c(VProgressCircular,{attrs:{"color":"primary","indeterminate":"","size":"64"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }